import React, { Component } from 'react';
import DispatchProps from "../../../utils/DispatchProps";
import Table from "../../Table";
import { WorkloadInfo } from '../../../models/WorkloadInfo';

interface WorkloadDefinitionTableProps {
    workloadInfos?: WorkloadInfo[];
}

interface WorkloadDefinitionTableState {
}

export class WorkloadDefinitionTable extends Component<WorkloadDefinitionTableProps, WorkloadDefinitionTableState> {
    static displayName = WorkloadDefinitionTable.name;

    private static readonly columns = [
        { title: "Name", propertyPath: "name", flex: 2 },
        { title: "Description", propertyPath: "description", flex: 5 },
        { title: "Admin only", propertyPath: "visibleToAdminsOnly", flex: 5 },
    ];

    constructor(props: WorkloadDefinitionTableProps) {
        super(props);

        this.state = {
        }
    }

    async componentDidMount() {
    }

    async componentDidUpdate(prevProps: Readonly<WorkloadDefinitionTableProps & DispatchProps>, prevState: any): Promise<void> {

    }

    render() {
        return (
            <Table
                title={"Workload Definitions"}
                columns={WorkloadDefinitionTable.columns}
                items={this.props.workloadInfos!}
                loading={this.props.workloadInfos === undefined}
                className={"cdb-table--enable-hover"}
            />
        );
    }
}
